import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { pageTitle } from "../../../../store/softSlice";
import AppURL from "../../../../widgets/AppURL";
import InputTextBox from "../../../../widgets/InputTextBox";
import { postDataToTheServer } from "../../../../widgets/api";
import { useFormik } from "formik";
import { ToastWarning } from "../../../../widgets/ToastMessage";
import { useNavigate } from "react-router-dom";

const EveryTeacherAccessLoginView = ({ setIconsButton, PageTitle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(pageTitle({ title: PageTitle }));
    document.title = `${PageTitle}`;
    setIconsButton(null);
  }, []);
  const { menu_list } = useSelector((state) => state?.software);
  const Org_Details = menu_list?.structure;

  const initialValues = {
    username: "",
    password: "",
  };

  const { values, handleSubmit, handleBlur, handleChange, errors, touched } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: async (values, action) => {
        const formData = new FormData();
        formData.append("username", values.username);
        formData.append("password", values.password);
        try {
          await postDataToTheServer(
            AppURL.LMS + "teacher-login-api-view/",
            formData
          ).then((res) => {
            if (res?.status === 200) {
              sessionStorage.setItem("teacherAuth", res?.user_data?.member_sn);
              sessionStorage.setItem("full_name", res?.user_data?.full_name);
              sessionStorage.setItem("teacherIsLogin", true);
              navigate("/only-teacher-dashboard-view")
            } else {
              ToastWarning("Your username and password is wrong");
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
    });
  return (
    <Fragment>
      
      <div className="flex min-h-full flex-col justify-center px-6 py-10 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md px-6 py-2 rounded-md bg-white shadow-xl">
          <div className="pt-4">
            <img
              className="mx-auto h-20 w-auto"
              src={AppURL.BaseURL + Org_Details?.logo}
              alt="Your Company"
            />
            <h2 className="mt-5 font-public-sans text-center text-2xl/9 font-bold tracking-tight text-gray-900">
              <span className="text-customPrimary"> Sign in</span> to teacher
              account
            </h2>
          </div>

          <div className="pt-10 sm:mx-auto">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <div className="mt-1">
                  <InputTextBox
                    type={"text"}
                    label={"Username"}
                    name={"username"}
                    value={values.username}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    errors={errors.username}
                  />
                </div>
              </div>

              <div className="mb-6">
                <InputTextBox
                  type={"password"}
                  label={"Password"}
                  name={"password"}
                  value={values.password}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  errors={errors.password}
                />
              </div>
              <div className="">
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-sm bg-customPrimary font-public-sans px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-customPrimary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Sign in
                </button>
              </div>
            </form>
            <p className="my-5 text-center text-sm/6 text-gray-500">
              Teacher login only.
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EveryTeacherAccessLoginView;
